import { useQuery } from "react-query";
import { RestError } from "../../services/rest-service/RestService";
import { IEditUserDTO } from "../../services/user-role-administration-service/Models";
import UserRoleAdministrationService from "../../services/user-role-administration-service/UserRoleAdministrationService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseUserParameters = {
    groupID: number;
    userID: number;
} & BaseUseQueryParameters<IEditUserDTO>;

export function useUser({
    groupID,
    userID,
    enabled,
    onError,
    onSuccess
}: UseUserParameters) {
    return useQuery<IEditUserDTO, RestError, IEditUserDTO>(
        keys.user(userID),
        ({ signal }) => {
            if(userID > -1){
                return UserRoleAdministrationService.getUser(groupID, userID, signal);
            } else {
                return Promise.resolve(UserRoleAdministrationService.createDefaultUser(-1));
            }
        },
        {
            enabled,
            onError,
            onSuccess,
            staleTime: 0
        }
    );
}
